/** @format */

import { Suspense } from "react";

import { RouterProvider } from "react-router-dom";
import { createBrowserRouter } from "react-router-dom";
import { useAppSelector } from "src/store/hook";
import * as RoleSelector from "src/store/role/selector";

// Routers
import { UserRouters, EmployerRouters, PublicRouters } from "../router";
import { AuthRouter } from "../configs/routes.config/auth-route";

// const userRouter = createBrowserRouter(
//   [...PublicRouter, ...UserRouters, ...AuthRouter, ...ChatRouter],
//   { basename: process.env.PUBLIC_URL }
// );

// const employerRouter = createBrowserRouter(
//   [...EmployerRouters, ...AuthRouter, ...ChatRouter],
//   { basename: process.env.PUBLIC_URL }
// );

const router = createBrowserRouter(
  [...PublicRouters, ...AuthRouter, ...UserRouters, ...EmployerRouters],
  { basename: process.env.PUBLIC_URL }
);

const Layout = () => {
  const role = useAppSelector(RoleSelector.selectUserRole);
  console.log("Role:", role);
  return (
    <Suspense>
      <RouterProvider router={router} />
    </Suspense>
  );
};

export default Layout;
